<template>
  <div>
    <label class="d-inline-flex align-items-center fw-normal">
      <b-form-select
          size="sm"
          v-model="perPage"
          :options="availablePerPageOptions"
          class="form-control form-select form-select-sm"
          @input="$emit('input', perPage)"
      ></b-form-select>
    </label>
    {{ $t('components.perpage_selector.title') }}
  </div>
</template>

<script>
export default {
  name: "PerPageSelector",
  props: {
    availablePerPageOptions: [],
  },
  data() {
    return {
      perPage: this.availablePerPageOptions[0]
    }
  }
}
</script>

<style scoped>

</style>